class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
      document.dispatchEvent(new Event('cart:updated'));
      document.dispatchEvent(new Event('cart_page:updated'));
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    document.dispatchEvent(new Event('cart:updated'));
    document.dispatchEvent(new Event('cart_page:updated'));
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);
    document.dispatchEvent(new Event('cart:updated'));
    document.dispatchEvent(new Event('cart_page:updated'));
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    var self = this;

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        var parsedState = JSON.parse(state);

        if (parsedState.errors) {
          var qtyEl = document.getElementById('Quantity-' + line) || document.getElementById('Drawer-quantity-' + line);
          if (qtyEl) qtyEl.value = qtyEl.getAttribute('value');
          self.updateLiveRegions(line, parsedState.errors);
          return;
        }

        handleFreeGift();

        // Scan all items for bundle groups; sync dropper to parent or remove orphaned
        var dropperUpdate = null;
        parsedState.items.forEach(function(item) {
          if (dropperUpdate) return;
          if (!item.properties || !item.properties._bundle_group) return;
          var bg = item.properties._bundle_group;
          var isDropper = item.properties._is_dropper;
          var partner = parsedState.items.find(function(i) {
            return i.key !== item.key && i.properties && i.properties._bundle_group === bg;
          });
          if (!partner) return;
          var partnerIsDropper = partner.properties._is_dropper;
          if (isDropper && !partnerIsDropper) {
            if (item.quantity !== partner.quantity) {
              dropperUpdate = { key: item.key, quantity: partner.quantity };
            }
          } else if (!isDropper && partnerIsDropper) {
            if (partner.quantity !== item.quantity) {
              dropperUpdate = { key: partner.key, quantity: item.quantity };
            }
          }
        });
        if (!dropperUpdate) {
          parsedState.items.forEach(function(item) {
            if (dropperUpdate) return;
            if (!item.properties || !item.properties._is_dropper) return;
            var bg = item.properties._bundle_group;
            if (!bg) return;
            var parentExists = parsedState.items.some(function(i) {
              return i.key !== item.key && i.properties && i.properties._bundle_group === bg && !i.properties._is_dropper;
            });
            if (!parentExists) dropperUpdate = { key: item.key, quantity: 0 };
          });
        }

        if (dropperUpdate) {
          return fetch(routes.cart_change_url, { ...fetchConfig(), ...{
            body: JSON.stringify({
              id: dropperUpdate.key,
              quantity: dropperUpdate.quantity,
              sections: self.getSectionsToRender().map(function(s) { return s.section; }),
              sections_url: window.location.pathname,
            })
          } }).then(function(r) { return r.json(); });
        }

        return parsedState;
      })
      .then(function(finalState) {
        if (!finalState || finalState.errors) return;

        var quantityElement =
          document.getElementById('Quantity-' + line) || document.getElementById('Drawer-quantity-' + line);
        var items = document.querySelectorAll('.cart-item');

        self.classList.toggle('is-empty', finalState.item_count === 0);
        var cartDrawerWrapper = document.querySelector('cart-drawer');
        var cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', finalState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', finalState.item_count === 0);

        self.getSectionsToRender().forEach(function(section) {
          var elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = self.getSectionInnerHTML(
            finalState.sections[section.section],
            section.selector
          );
        });

        var updatedValue = finalState.items[line - 1] ? finalState.items[line - 1].quantity : undefined;
        var message = '';
        if (items.length === finalState.items.length && updatedValue !== parseInt(quantityElement ? quantityElement.value : 0)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        self.updateLiveRegions(line, message);

        var lineItem =
          document.getElementById('CartItem-' + line) || document.getElementById('CartDrawer-Item-' + line);
        if (lineItem && lineItem.querySelector('[name="' + name + '"]')) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector('[name="' + name + '"]'))
            : lineItem.querySelector('[name="' + name + '"]').focus();
        } else if (finalState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: finalState, variantId: variantId });
        document.dispatchEvent(new Event('cart:updated'));
        document.dispatchEvent(new Event('cart_page:updated'));
      })
      .catch(function() {
        self.querySelectorAll('.loading__spinner').forEach(function(overlay) { overlay.classList.add('hidden'); });
        var errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors) errors.textContent = window.cartStrings.error;
      })
      .finally(function() {
        self.disableLoading(line);
      });
  }

  updateprogresss(val) {
    setTimeout(function () {
      var element = document.getElementById("myprogressBar");
      var currentWidth = parseFloat(element.style.width) || 0;
      if (currentWidth < val) {

        var width1 = currentWidth;
        var identity1 = setInterval(scene1, 10);

        function scene1() {

          if (width1 >= val) {
            clearInterval(identity1);

          } else {
            width1++;
            element.style.width = width1 + '%';

          }
        }
      } else {
        var width2 = currentWidth;
        var identity2 = setInterval(scene2, 10);
        function scene2() {
          if (width2 <= val) {
            clearInterval(identity2);

          } else {
            width2--;
            element.style.width = width2 + '%';

          }
        }
      }
    }, 800)
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

$(document).on('click', '.rebuy-product-actions', function () {
  setTimeout(function () {
    document.dispatchEvent(new Event('cart_page:updated'));
    fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = ['cart-drawer-items', '.drawer__footer', '.item-count'];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
        $('.drawer__inner-empty').remove()
        $('cart-drawer.drawer').removeClass('is-empty')
        $('cart-drawer.drawer').addClass('active')
      })
      .catch((e) => {
        console.error(e);
      });
  }, 1200)
});


if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

$(document).ready(function () {
  document.addEventListener('cart_page:updated', updateCartPage);
  function updateCartPage() {
    setTimeout(() => {
      fetch(`${routes.cart_url}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-items', '.cart__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }, 2000);
  }
  document.addEventListener('cart:updated', updateCartDrawer);
  function updateCartDrawer() {
    setTimeout(() => {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });

      fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const targetElement = document.querySelector('.cart-count-bubble');
          const sourceElement = html.querySelector('.cart-count-bubble');
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          } else {
            targetElement.remove();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }, 2000);
  }
});

document.addEventListener("DOMContentLoaded", function() {
  window.handleFreeGift(); // auto-run once on page load
  window.handleAutoAddProducts(); // auto-run once on page load

  // Clean up orphaned or invalid dropper items on page load
  fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
    cart.items.forEach(function(drop) {
      if (!drop.properties || !drop.properties._is_dropper) return;
      var bg = drop.properties._bundle_group;
      if (!bg) {
        // No bundle group — orphaned, remove
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: drop.key, quantity: 0 }),
        });
        return;
      }
      var parentExists = cart.items.some(function(i) {
        return i.key !== drop.key && i.properties && i.properties._bundle_group === bg && !i.properties._is_dropper;
      });
      if (!parentExists) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: drop.key, quantity: 0 }),
        });
      }
    });
  }).catch(function(e) { console.error('Dropper cleanup error:', e); });
});

window.handleFreeGift = async function () {
  if (window.customerIsBlocked) return;
  const box = document.querySelector(".freshipping");
  if (!box) return;

  const threshold = +box.dataset.freegift;
  const variantId = box.dataset.freegiftVariant;

  if (!variantId || !threshold || threshold <= 0) return;

  try {
    const cart = await fetch("/cart.js").then(r => r.json());
    const hasGift = cart.items.some(i => i.variant_id == variantId);

    if (cart.items_subtotal_price >= threshold && !hasGift) {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });
      document.dispatchEvent(new Event("cart:updated"));
    }

    if (cart.items_subtotal_price < threshold && hasGift) {
      const gift = cart.items.find(i => i.variant_id == variantId);
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: gift.key, quantity: 0 }),
      });
      document.dispatchEvent(new Event("cart:updated"));
    }
  } catch (e) {
    console.error("FreeGift Error:", e);
  }
};

// Auto add-on: keeps the product set in the trigger product's custom.auto_add_product
// metafield in the cart with the same quantity, and removes it with the trigger product.
var autoAddSyncing = false;
var autoAddPending = false;

window.handleAutoAddProducts = async function () {
  if (window.customerIsBlocked) return;
  if (autoAddSyncing) {
    autoAddPending = true;
    return;
  }
  autoAddSyncing = true;

  try {
    const sections = await fetch(`${window.Shopify.routes.root}cart?sections=auto-add-products`).then(r => r.json());
    const html = new DOMParser().parseFromString(sections["auto-add-products"], "text/html");
    const dataEl = html.querySelector("[data-auto-add-products]");
    if (!dataEl) return;
    const lines = JSON.parse(dataEl.textContent);

    // Quantity each auto-add variant should have, summed across its trigger lines
    const required = {};
    lines.forEach(line => {
      if (line.is_auto_add || !line.auto_add_variant_id) return;
      required[line.auto_add_variant_id] = (required[line.auto_add_variant_id] || 0) + line.quantity;
    });

    const updates = {};
    const synced = {};
    lines.forEach(line => {
      if (!line.is_auto_add) return;
      const target = synced[line.variant_id] ? 0 : (required[line.variant_id] || 0);
      synced[line.variant_id] = true;
      if (line.quantity !== target) updates[line.key] = target;
    });

    const itemsToAdd = Object.keys(required)
      .filter(variantId => !synced[variantId])
      .map(variantId => ({
        id: parseInt(variantId, 10),
        quantity: required[variantId],
        properties: { _is_auto_add: "true" },
      }));

    if (!Object.keys(updates).length && !itemsToAdd.length) return;

    if (Object.keys(updates).length) {
      const cart = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: updates }),
      }).then(r => r.json());

      // Removing the auto-added item can leave the cart empty
      const isEmpty = cart.item_count === 0;
      const cartDrawer = document.querySelector("cart-drawer");
      const cartFooter = document.getElementById("main-cart-footer");
      const cartItems = document.querySelector("cart-items");
      if (cartDrawer) cartDrawer.classList.toggle("is-empty", isEmpty);
      if (cartFooter) cartFooter.classList.toggle("is-empty", isEmpty);
      if (cartItems) cartItems.classList.toggle("is-empty", isEmpty);
    }
    if (itemsToAdd.length) {
      await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: itemsToAdd }),
      });
    }
    document.dispatchEvent(new Event("cart:updated"));
    document.dispatchEvent(new Event("cart_page:updated"));
  } catch (e) {
    console.error("AutoAdd Error:", e);
  } finally {
    autoAddSyncing = false;
    if (autoAddPending) {
      autoAddPending = false;
      window.handleAutoAddProducts();
    }
  }
};

// Re-sync after any cart change, whichever add-to-cart or cart form made it
if (!window.autoAddFetchPatched) {
  window.autoAddFetchPatched = true;
  const originalFetch = window.fetch;
  window.fetch = function (resource, options) {
    const url = typeof resource === "string" ? resource : (resource && resource.url) || "";
    const request = originalFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      request.then(function () { window.handleAutoAddProducts(); }).catch(function () {});
    }
    return request;
  };
}
